import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  getReplenishmentRequests,
  getReplenishmentRequestsWithStatus,
} from "../../services/AllServices";
import { showMessage } from "../../utils/helpers";

const useReplenishmentRequestViewController = () => {
  const { id } = useParams();
  const [requestId, setRequestId] = useState(null);
  const [status, setStatus] = useState("pending");
  const [requests, setRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMoreItems, setHasMoreItems] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const pageSize = 15;
  const totalPages = Math.ceil(totalCount / pageSize);

  const handlePageChange = (page) => {
    if (page > totalPages || page < 1 || !hasMoreItems) {
      return;
    }

    setCurrentPage(page);
  };

  useEffect(() => {
    fetchRequests();
  }, [status, currentPage]);

  const fetchRequests = async () => {
    setIsLoading(true);
    try {
      let response;
      if (status === "") {
        response = await getReplenishmentRequests(currentPage, pageSize);
      } else {
        response = await getReplenishmentRequestsWithStatus(
          currentPage,
          pageSize,
          status
        );
      }
      if (response?.data?.requests?.length > 0) {
        setRequests(response.data.requests);
        setHasMoreItems(true);
      } else {
        setRequests([]);
        setHasMoreItems(false);
      }
      setTotalCount(response?.data?.total_count);
    } catch (error) {
      console.log("error", error);
      showMessage(
        "error",
        error?.response?.data?.message || "Something went wrong"
      );
    }
    setIsLoading(false);
  };

  return {
    isLoading,
    requests,
    currentPage,
    totalPages,
    handlePageChange,
    status,
    setStatus,
  };
};

export default useReplenishmentRequestViewController;
